import type { PagedReviewsContentItem } from './pagedReviewsContentItem';

/**
 * 페이지네이션된 리뷰 목록
 */
export interface PagedReviews {
  /** 리뷰 목록 */
  content: PagedReviewsContentItem[];
  /** 마지막 페이지 여부 */
  last: boolean;
  /** 현재 페이지 번호 (0부터 시작) */
  page: number;
  /** 페이지당 항목 수 */
  size: number;
  /** 전체 항목 수 */
  totalElements: number;
  /** 전체 페이지 수 */
  totalPages: number;
}
